import { defineComponent, h } from "vue";

export const IconSearch = defineComponent({
  setup() {
    return () =>
      h(
        "svg",
        {
          class: "tdt-icon",
          t: "1636975674954",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "7028",
          width: "200",
          height: "200"
        },
        [
          h("path", {
            d: "M789.804097 737.772047 742.865042 784.699846 898.765741 940.600545 945.704796 893.672746Z",
            "p-id": "7029"
          }),
          h("path", {
            d: "M456.92259 82.893942c-209.311143 0-379.582131 170.282245-379.582131 379.582131s170.270988 379.570875 379.582131 379.570875c209.287607 0 379.558595-170.270988 379.558595-379.570875S666.210197 82.893942 456.92259 82.893942zM770.128989 462.477097c0 172.721807-140.508127 313.229934-313.206398 313.229934-172.720783 0-313.229934-140.508127-313.229934-313.229934s140.508127-313.229934 313.229934-313.229934C629.620861 149.247162 770.128989 289.75529 770.128989 462.477097z",
            "p-id": "7030"
          })
        ]
      );
  }
});

export const IconRoute = defineComponent({
  setup() {
    return () =>
      h(
        "svg",
        {
          class: "tdt-icon",
          t: "1638934785539",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "8230",
          width: "200",
          height: "200"
        },
        [
          h("path", {
            d: "M301.952 387.669333l144.981333 54.357334c56.234667 21.077333 113.578667 80.597333 132.565334 137.557333l15.658666 46.933333a42.666667 42.666667 0 1 1-80.981333 26.965334l-15.616-46.933334c-10.88-32.512-49.493333-72.533333-81.578667-84.608L155.733333 423.936c-38.016-14.250667-36.522667-68.565333 2.261334-80.64l682.666666-213.333333a42.666667 42.666667 0 0 1 53.418667 53.418666l-213.333333 682.666667a42.666667 42.666667 0 0 1-81.408-25.429333l189.013333-604.928-486.4 151.978666z",
            "p-id": "8231"
          })
        ]
      );
  }
});

export const IconClose = defineComponent({
  setup() {
    return () =>
      h(
        "svg",
        {
          class: "tdt-icon",
          t: "1636975957032",
          viewBox: "0 0 1024 1024",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "p-id": "7161",
          width: "200",
          height: "200"
        },
        [
          h("path", {
            d: "M562.281173 510.800685l294.996664-293.466821c13.94971-13.878079 14.020318-36.367279 0.14224-50.316989-13.913894-13.984503-36.367279-14.020318-50.316989-0.14224L512.034792 460.377272 219.528855 166.982082c-13.842263-13.878079-36.367279-13.94971-50.316989-0.071631-13.913894 13.878079-13.948687 36.403095-0.071631 50.352805L461.576587 510.587837 166.721139 803.876604c-13.94971 13.878079-14.020318 36.367279-0.14224 50.316989 6.939039 6.974855 16.084327 10.497075 25.229614 10.497075 9.073656 0 18.148335-3.451612 25.087375-10.354835l294.926056-293.360398 295.17472 296.064996c6.939039 6.974855 16.048511 10.462283 25.193799 10.462283 9.109472 0 18.184151-3.487428 25.12319-10.390651 13.913894-13.878079 13.94971-36.367279 0.071631-50.316989L562.281173 510.800685z",
            "p-id": "7162"
          })
        ]
      );
  }
});
